export default __webpack_public_path__ + "static/media/forbs.80e032fe.png";